/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirmation_Cannot_Be_UndoneInputs */



/**
* | output |
* | --- |
* | "This action cannot be undone" |
*
* @param {Confirmation_Cannot_Be_UndoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const confirmation_cannot_be_undone = /** @type {((inputs?: Confirmation_Cannot_Be_UndoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirmation_Cannot_Be_UndoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Aktion kann nicht rückgängig gemacht werden")
	return /** @type {LocalizedString} */ ("This action cannot be undone")
});